import React, { useEffect, useRef } from "react";
import io from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";

import { timeEntryReduxStateDataSuccess } from "../../store/timeEntries/action";
import { toast } from "react-toastify";
import { userOnlineStatusSuccess } from "../../store/auth/login/actions";
import {
  getMessagingConversationData,
  getMessagingConversationDataSuccess,
} from "../../store/MessagingService/action";
import { useHistory } from "react-router-dom";
import TasksCrmIt from "../../store/tasksCrmIT/reducer";
import { getTasksCrmITList } from "../../store/tasksCrmIT/action";
import { internalTerminalPaymentResultSuccess } from "../../store/posSystem/action";
import { WHATSAPP_EVENT, currentUserId } from "../WhatsApp/whatsappUtils";

const HeartBeat = () => {
  let url;
  const history = useHistory();
  switch (true) {
    case window.location.hostname?.includes("portal.crmit"):
      url = "https://prod-heartbeat.crmit.app";
      break;
    case window.location.hostname?.includes("dev01.crmit") ||
      window.location.hostname?.includes("dev02.crmit") ||
      window.location.hostname?.includes("qa01.crmit"):
      url = "dev02-heartbeat.crmit.app";
      break;
    case window.location.hostname?.includes("localhost"):
      url = "http://localhost:5000";
      break;
    default:
      break;
  }
  const localData = JSON?.parse(localStorage.getItem("authUser"));

  const dispatch = useDispatch();
  const userId = localData?.get_user_data?.User_IdExternal;
  const companyId = localData?.get_company_data?.Company_IdExternal;

  const TASKS_ROOM = companyId ? `tasks_${companyId}` : null;

  const { userOnlineStatus } = useSelector((state) => ({
    userOnlineStatus: state.Login.userOnlineStatus,
  }));
  const { taskUseHeartbeat } = useSelector((state) => ({
    taskUseHeartbeat: state.TasksCrmIt.taskUseHeartbeat,
  }));

  const socketRef = useRef(null);
console.log(`pos_payment_update_${companyId}_${userId}`, `pos_payment_update_${companyId}_${userId}`);
  useEffect(() => {
    if (!url || !companyId || !userId) return;

    const socket = io.connect(url);
    socketRef.current = socket;

    socket.on("connect", () => {
      socket.emit("login", { userId });
      socket.emit("join", `${companyId}_${userId}`);
      socket.emit("join", `pos_payment_update_${companyId}_${userId}`);

      // --- NEW: Join Company-Wide POS Sync Room ---
      socket.emit("join", `pos_system_sync_${companyId}`);

      socket.emit("join", `messaging_center_${companyId}`);
      socket.emit("join", `messaging_center_${companyId}_${userId}`);
    });

    return () => {
      socket.disconnect();
    };
  }, [url, companyId, userId]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && socketRef.current) {
        socketRef.current.emit("login", { userId });
        socketRef.current.emit("join", `${companyId}_${userId}`);
        socketRef.current.emit(
          "join",
          `pos_payment_update_${companyId}_${userId}`
        );

        // --- NEW: Re-Join Company-Wide POS Sync Room on wake ---
        socketRef.current.emit("join", `pos_system_sync_${companyId}`);

        socketRef.current.emit(
          "join",
          `messaging_center_${companyId}_${userId}`
        );
        socketRef.current.emit("join", `messaging_center_${companyId}`);
        if (taskUseHeartbeat && TASKS_ROOM)
          socketRef.current.emit("join", TASKS_ROOM);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [taskUseHeartbeat, companyId, userId, TASKS_ROOM]);

  useEffect(() => {
    const socket = socketRef.current;
    if (!socket || !TASKS_ROOM) return;

    const onTasksUpdated = (payload) => {
      if (!taskUseHeartbeat) return;
      dispatch(getTasksCrmITList());
      toast.info("Tasks list updated");
    };

    if (taskUseHeartbeat) {
      socket.emit("join", TASKS_ROOM);
      socket.on("tasks_updated", onTasksUpdated);
    } else {
      socket.off("tasks_updated", onTasksUpdated);
      socket.emit("leave", TASKS_ROOM);
    }

    return () => {
      socket.off("tasks_updated", onTasksUpdated);
      if (taskUseHeartbeat) socket.emit("leave", TASKS_ROOM);
    };
  }, [taskUseHeartbeat, TASKS_ROOM, dispatch]);

  const { timeEntryData } = useSelector((state) => ({
    timeEntryData: state.TimeEntries.timeEntryData,
  }));

  const { timeEntryUpdateSuccessAPI } = useSelector((state) => ({
    timeEntryUpdateSuccessAPI: state.TimeEntries.timeEntryUpdate,
  }));

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        timeEntryUpdateSuccessAPI &&
        typeof timeEntryUpdateSuccessAPI === "object" &&
        timeEntryUpdateSuccessAPI?.status === 200
      ) {
        socketRef.current?.emit("join", companyId + "_" + userId);
        socketRef.current?.emit("send_timeEntry", timeEntryData);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [timeEntryUpdateSuccessAPI, companyId, userId, timeEntryData]);

  useEffect(() => {
    const socket = socketRef.current;
    if (!socket) return;

    socket.on(`${companyId}_${userId}`, (data) => {
      if (data?.timeentry_data?.Staff_Id === userId) {
        dispatch(timeEntryReduxStateDataSuccess(data));
      }
    });

    socket.on("receive_notification", (data) => toast(data));
    socket.on("Test", (data) => toast(data));
    socket.on("user_online", (data) =>
      dispatch(userOnlineStatusSuccess(data?.userOnline))
    );
    socket.on("disconnect", () => dispatch(userOnlineStatusSuccess(false)));

    socket.on("pos_payment_update", (data) => {
      dispatch(internalTerminalPaymentResultSuccess(data));
    });

    // --- NEW: Listen for Global Ticket Syncs ---
    socket.on("pos_tickets_update", (data) => {
      dispatch({
        type: "INTERNAL_POS_SYSTEM_TICKETS_UPDATE_SUCCESS",
        payload: data,
      });
    });

    socket.on("messaging_service", (payload) => {
      const { data, message } = payload || {};
      dispatch(getMessagingConversationDataSuccess(data));

      // Change #100326 - re-fire for the WhatsApp inbox / tabs (useWhatsAppEvents), and fix the
      // toast: it used to open the MESSAGE id as if it were the conversation id.
      const conversation = data?.messagingconversation_data || null;
      const conversationMessage = data?.messageconversationmessage_data || null;
      try {
        window.dispatchEvent(
          new CustomEvent(WHATSAPP_EVENT, {
            detail: {
              kind: data?.kind || "MESSAGE",
              conversation,
              message: conversationMessage,
              title: message?.title,
              showNotification: message?.flagshownotification === "1",
            },
          })
        );
      } catch (_) {
        // never let a listener break the socket handler
      }

      const MessageTitle = message?.title;
      const MessageBody = message?.body;
      const MessagingConversation_Id =
        conversation?.Id || conversationMessage?.MessagingConversation_Id;
      // Only the assignee is pinged; unassigned conversations ping everyone. Nobody is pinged
      // about the conversation they already have open.
      const assignedTo = conversation?.AssignedUser_Id;
      const forMe = !assignedTo || String(assignedTo) === String(currentUserId());
      const alreadyOpen =
        MessagingConversation_Id &&
        window.location.pathname.startsWith(`/messaging-service/${MessagingConversation_Id}/`) &&
        document.visibilityState === "visible";
      const flagshownotification =
        message?.flagshownotification === "1" && forMe && !alreadyOpen;

      if (flagshownotification) {
        toast.info(
          ({ closeToast }) => (
            <div>
              <strong>{MessageTitle || "Notification"}</strong>
              <p>{MessageBody || "No message body"}</p>
              {MessagingConversation_Id && (
                <button
                  onClick={() => {
                    closeToast();
                    history.push(
                      `/messaging-service/${MessagingConversation_Id}/view`
                    );
                  }}
                  className="btn btn-sm btn-primary mt-2"
                >
                  Open Conversation
                </button>
              )}
            </div>
          ),
          { autoClose: 8000, closeOnClick: false }
        );
      }
    });

    return () => {
      socket.off(`${companyId}_${userId}`);
      socket.off("receive_notification");
      socket.off("Test");
      socket.off("user_online");
      socket.off("disconnect");
      socket.off("pos_payment_update");
      socket.off("pos_tickets_update"); // Cleanup
      socket.off("messaging_service");
    };
  }, [companyId, userId, dispatch, history]);

  // Twilio is provided once at the app root (App.js). HeartBeat must NOT mount
  // its own TwilioCallProvider — a second provider registers a duplicate Twilio
  // Device and keeps separate call refs, which is why the drawer's End button
  // could not hang up a call accepted via this component's popup.
  return null;
};

export default HeartBeat;
